if (typeof VideoPopup !== 'function') {

  class VideoPopup extends HTMLElement {

    constructor() {
      super();

      document.addEventListener('click', e => {
        const link = e.target.closest('[data-js-video-popup-link]');
        if (!link) return;

        e.preventDefault();
        const videoComponent = link.closest('video-component');
        if (!videoComponent) return;

        // Crea il blackout
        const blackout = document.createElement('div');
        blackout.classList.add('video-popup__blackout');
        videoComponent.appendChild(blackout);
        setTimeout(() => { blackout.style.opacity = '1'; }, 10);
        videoComponent.classList.add('video-opened');

        // Aggiungi il template del video
        // Aggiungi il template del video solo se non esiste già
const container = videoComponent.querySelector('[data-js-video-component-container]');
const existingMedia = container.querySelector('video, iframe');
if(!existingMedia) {
  // Nascondi immagine di background subito
  const bg = videoComponent.querySelector('.video-component__background');
  if(bg) bg.style.display = 'none';

  const templateContent = videoComponent.querySelector('template').content.firstElementChild.cloneNode(true);
  container.appendChild(templateContent);
}

// Play media dopo mount
setTimeout(() => {
  const mediaType = videoComponent.dataset.productMediaType;
  const mediaEl = container.querySelector('video, iframe');

  if(!mediaEl) return; // niente da fare

  switch(mediaType) {
    case 'video':
      if(mediaEl.tagName.toLowerCase() === 'video') {
        mediaEl.muted = true;
        mediaEl.playsInline = true;
        mediaEl.loop = true;

        mediaEl.addEventListener('playing', () => {
          const bg = videoComponent.querySelector('.video-component__background');
          if(bg) bg.style.display = 'none';
        });

        mediaEl.play().catch(() => console.log('Autoplay bloccato su mobile'));
      }
      break;

    case 'external_video-youtube':
      container.querySelector('.js-youtube')?.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}', '*'
      );
      break;

    case 'external_video-vimeo':
      container.querySelector('.js-vimeo')?.contentWindow.postMessage(
        '{"method":"play"}', '*'
      );
      break;
  }
}, 500);



        // Gestione chiusura
        const closeBtn = videoComponent.querySelector('[data-js-video-component-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            container.querySelectorAll('iframe, video').forEach(el => el.remove());
            blackout.remove();
            videoComponent.classList.remove('video-opened');
          });
        }
      });
    }
  }

  if (typeof customElements.get('video-popup') === 'undefined') {
    customElements.define('video-popup', VideoPopup);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const videoComponents = document.querySelectorAll('video-component');

  videoComponents.forEach(vc => {
    if(vc.dataset.autoplay === "true") {
      const link = vc.querySelector('[data-js-video-popup-link]');
      if(link) {
        // Simula il click per far partire il popup e il video
        link.click();
      }
    }
  });
});
